import React, { useState } from "react";
import { useAuth } from "../Context/AuthContext";
import {
    TextField,
    Button,
    Typography,
    Box,
    Alert,
    Paper,
    Container,
} from "@mui/material";
import { useLoading, useSoftwareVersion } from "../Context/Contexts";
import logo from "../assets/Bex_vit2.png";
import { useTranslation } from "react-i18next";

const LoginForm: React.FC = () => {
    const { authService, setIsAuthenticated } = useAuth();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const { showLoading, hideLoading } = useLoading();
    const { version, isFetching } = useSoftwareVersion();
    const { t } = useTranslation();
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError("");

        try {
            showLoading(); 
            await authService.login(username, password);
            setIsAuthenticated(true);
        } catch (err: any) {
            setError(getLoginErrorMessage(err?.response?.data));
        }
        finally {
            hideLoading(); 
        }
    };

    function getLoginErrorMessage(errorData: any): string {
        if (!errorData) return t("dialog.loginFailed");

        if (errorData.includes("Invalid login request.")) {
            return t("dialog.invalidLoginRequest");
        }

        if (errorData.includes("Account is locked")) {
            return t("dialog.accountLocked");
        }

        if (errorData.includes("Invalid username or password.")) {
            return t("dialog.invalidCredentials");
        }

        return `${t("dialog.loginFailed")} ${errorData}`;
    }

    return (
        <Container maxWidth="xs">
            <Paper
                elevation={3}
                sx={{
                    padding: 4,
                    marginTop: 4,
                    borderRadius: 2,
                    textAlign: "center",
                }}
            >
                <img src={logo} alt="Bex Logo" style={{ width: 150, marginBottom: 20 }} />
                <form onSubmit={handleSubmit}>
                    <Box sx={{ marginBottom: 2 }}>
                        <TextField
                            fullWidth
                            label={t("common.username")}
                            variant="outlined"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                    </Box>
                    <Box sx={{ marginBottom: 2 }}>
                        <TextField
                            fullWidth
                            label={t("common.password")}
                            type="password"
                            variant="outlined"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </Box>
                    <Button type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        size="large"
                        sx={{ marginTop: 2 }}
                    >
                        {t("common.login")}
                    </Button>
              
                    </form>
                {error && (
                    <Alert severity="error" sx={{ marginTop: 2 }}>
                        {error}
                    </Alert>
                )}
             
            </Paper>

            <Box
                sx={{
                    textAlign: "center",
                    mt: 2,
                    fontSize: "0.8rem",
                    color: "text.secondary",
                    opacity: 0.7,
                }}
            >
                {isFetching ? "Loading..." : version ? `v${version}` : ""}
            </Box>
        </Container>
    );
};

export default LoginForm;